import {Component, HostBinding, inject} from '@angular/core';
import {MainComponent} from '@core/main.component';
import {BottomMenuItem} from '@core/classes/bottom-menu';
import {ActivatedRoute} from '@angular/router';
import {CordovaService} from '@services/cordova.service';
import {QrCodeModalComponent} from '@components/modals/qr-code/item';
import {ModalService} from '@services/modal.service';

@Component({
  selector: 'app-bottom-menu',
  templateUrl: 'item.html',
  styleUrls: ['item.scss']
})

export class BottomMenuComponent extends MainComponent {
  cordovaService = inject(CordovaService);
  modalService = inject(ModalService);
  hamsterIsLoaded = false;
  iconSize: number;
  qrIconSize: number;
  constructor(private route: ActivatedRoute) {
    super();
    this.appService.bottomMenu.setItems([
      {
        id: 'menu',
        icon: 'coffee',
        title: 'Меню',
        link: 'menu'
      },
      {
        id: 'main',
        icon: 'user',
        title: 'Главная',
        link: 'dashboard',
        translate: '-20'
      },
      {
        id: 'contacts',
        icon: 'location',
        title: 'Рестораны',
        link: 'contacts',
        translate: '20'
      },
      {
        id: 'chat',
        icon: 'messages',
        title: 'Чат',
        link: 'chat'
      }]);
    this.calculateIconSize();
    this.cordovaService.platform.resize.subscribe(() => {
      this.calculateIconSize();
    });
  }

  @HostBinding('class')
  get classes() {
    return {
      'bottom-panel-hidden': this.appService.bottomMenu.hidden || this.cordovaService.keyBoardShow,
    };
  }

  getItems(): BottomMenuItem[] {
    return this.appService.bottomMenu.getItems();
  }

  isActive(item: BottomMenuItem) {
    if (this.navigationService.isCurrentUrl(item.link)) {
      // Если текущий URL соответствует пункту меню, то устанавливаем класс `active`
      return true;
    } else if (!this.navigationService.currentUrl && item.link === 'dashboard') {
      // Если текущий URL не определен (т.е. мы на стартовой странице), и пункт меню - "dashboard", то устанавливаем класс `active`
      return true;
    } else {
      return false;
    }
  }

  onClick(index: number, item: BottomMenuItem) {
    switch (item.id) {
      case 'menu':
        this.navigationService.goTo('menu');
        break;
      case 'main':
        this.navigationService.goTo('dashboard');
        break;
      case 'contacts':
        this.navigationService.goTo('contacts');
        break;
      case 'chat':
        this.appService.getWindow().Verbox('openSupport');
        break;
    }
    this.appService.bottomMenu.emitClick(index);
  }

  openQrModal() {
    this.modalService.openModal(QrCodeModalComponent, {
      customBreakpoints: [0, 0.75]
    }, 'big', 'big',
    (res) => {
    });
  }

  hideHamster(event) {
    // Проверяем, был ли клик сделан по modal-wrapper, но не по modal
    if (event.target === event.currentTarget) {
      this.appService.hamsterQrRelocation = false;
    }
  }

  calculateIconSize() {
    const screenWidth = this.cordovaService.platform.width();
    this.iconSize = screenWidth / 13;
    this.qrIconSize = screenWidth / 11;
  }
}
